"use client"

// src/hooks/useIsChanged.ts
import { useEffect, useRef } from "react";
var usePrevious = (value) => {
  const ref = useRef(value);
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
};
var useIsChanged = (value) => usePrevious(value) !== value;

// src/hooks/useIsClient.ts
import { useState } from "react";

// src/hooks/useIsomorphicLayoutEffect.ts
import { useEffect as useEffect2, useLayoutEffect } from "react";
var useIsomorphicLayoutEffect = typeof window !== "undefined" ? useLayoutEffect : useEffect2;

// src/hooks/useIsClient.ts
var useIsClient = () => {
  const [isClient, setIsClient] = useState(false);
  useIsomorphicLayoutEffect(() => {
    setIsClient(true);
  }, []);
  return isClient;
};

// src/hooks/useTimeout.ts
import { useEffect as useEffect3, useRef as useRef2 } from "react";
var useTimeout = (fn, ms) => {
  const fnRef = useRef2(fn);
  useIsomorphicLayoutEffect(() => {
    fnRef.current = fn;
  }, [fn]);
  useEffect3(() => {
    const id = setTimeout(fnRef.current, ms);
    return () => clearTimeout(id);
  }, [ms]);
};

export {
  useIsChanged,
  useIsClient,
  useTimeout
};
//# sourceMappingURL=chunk-74XMCPAC.js.map